import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { DependantType } from './dependant-type.interface';

export class DependantTypeService {
   async getDependantTypes() {
      return await http.get<Array<DependantType>>(`/dependant-types`, cacheFirstConfig).then((response) => response.data);
   }
}
